import { useState, useEffect } from "react";

export interface IBreakpoints {
  isSm: boolean; // < 768px
  isMd: boolean;     // >= 768px
  isLg: boolean;     // >= 992px
  isXl: boolean;     // >= 1200px
}

const QUERIES = {
  isSm: "(max-width: 767.98px)",
  isMd: "(min-width: 768px)",
  isLg: "(min-width: 992px)",
  isXl: "(min-width: 1200px)",
} as const;

function getMatches(): IBreakpoints {
  return {
    isSm: window.matchMedia(QUERIES.isSm).matches,
    isMd: window.matchMedia(QUERIES.isMd).matches,
    isLg: window.matchMedia(QUERIES.isLg).matches,
    isXl: window.matchMedia(QUERIES.isXl).matches,
  };
}

export function useBreakpoints(): IBreakpoints {
  const [breakpoints, setBreakpoints] = useState<IBreakpoints>(getMatches);

  useEffect(() => {
    const mediaQueries = (Object.entries(QUERIES) as [keyof IBreakpoints, string][]).map(
      ([key, query]) => {
        const mql = window.matchMedia(query);
        const listener = () => setBreakpoints((prev) => ({ ...prev, [key]: mql.matches }));
        mql.addEventListener("change", listener);
        return () => mql.removeEventListener("change", listener);
      }
    );
    return () => mediaQueries.forEach((cleanup) => cleanup());
  }, []);

  return breakpoints;
}
